import { serviceDirectoryApiClient } from '@/services/service-directory';

class ApiInfo {
  fetchApisInfo = async (organisationId: string) => {
    const response = await serviceDirectoryApiClient.get('apis', {
      headers: {
        organisationId,
      },
    });
    return response.data;
  };
}

export const ApiInfoInstance = new ApiInfo();
